"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffsetCorrector = exports.PathBuilder = exports.Normalizer = void 0;
const widgets_1 = require("@tableau/widgets");
class Normalizer {
    constructor(values = [], width = 0, height = 0, originX = 0, originY = 0) {
        this.width = width;
        this.height = height;
        this.originX = originX;
        this.originY = originY;
        this.n = values.length - 1;
        this.max = Math.max(...values);
    }
    y(value) {
        // Because SVG's y axis starts with 0 at the top and increases downward, the normalization
        // also inverts the numbers on the axis so lower numbers appear lower on the screen.
        const y = (this.max <= 0) ? this.height : (this.max - value) * this.height / this.max;
        return y + this.originY;
    }
    x(i) {
        const x = (this.n === 0) ? this.width : i * this.width / this.n;
        return x + this.originX;
    }
}
exports.Normalizer = Normalizer;
class PathBuilder {
    constructor(normalize) {
        this.normalize = normalize;
    }
    // turns the values into a command readable by the path element
    buildMovement(name, x, y) {
        return `${name}${x},${y}`;
    }
    // creates a combined string of commands to be sent to a path element in the style created in buildMovement
    buildPath(dataPoints) {
        return dataPoints.reduce((movements, currentValue, index) => {
            // The (i === 0) check is to move to the start of the path ('M'), otherwise it is
            // creating a line from the previous to the current point ('L').
            const moveType = (index === 0) ? 'M' : 'L';
            const x = this.normalize.x(index);
            const y = this.normalize.y(currentValue);
            return movements + this.buildMovement(moveType, x, y);
        }, '');
    }
}
exports.PathBuilder = PathBuilder;
// Exported for the unit tests
class OffsetCorrector {
    constructor(element) {
        this.boundRect = element.getBoundingClientRect();
    }
    correctHorizontalOffset(element) {
        const elementRect = element.getBoundingClientRect();
        const textBuffer = widgets_1.TabStyles.Spacing.SmallSpace;
        const rightOverreach = elementRect.right - (this.boundRect.right - textBuffer);
        const leftOverreach = (this.boundRect.left + textBuffer) - elementRect.left;
        let n = 0;
        let totalCorrection = 0;
        if (rightOverreach > 0) {
            totalCorrection -= rightOverreach;
            n++;
        }
        if (leftOverreach > 0) {
            totalCorrection += leftOverreach;
            n++;
        }
        // Average the two corrections
        return n === 0 ? 0 : (totalCorrection / n);
    }
}
exports.OffsetCorrector = OffsetCorrector;
//# sourceMappingURL=SparklineUtilities.js.map